// export type { ConsultListChatLayoutProps };

import ChatPopup from './layout';

export default ChatPopup;
